<template>
    <div class="xiaofeijilu">
        <div class="tit">收入统计</div>
        <!-- <el-form inline>
            <el-form-item label="数据作者">
                <el-input placeholder="" style="width: 100px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select
                    v-model="lottery.value"
                    placeholder="请选择彩种"
                    style="width: 120px"
                >
                    <el-option
                        v-for="(item, index) in lottery.arr"
                        :key="index"
                        :value="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                    v-model="form.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索</el-button>
                <el-button type="primary">刷新</el-button>
            </el-form-item>
        </el-form> -->

		<div class="lottery_menu">
			<div 
				v-for="(item,index) in lottery.arr" :key="index" 
				:class="{active:lottery.active == index}"
				@click="toggle_income_statistics(item,index)"
			>
				{{item.label}}
			</div>
		</div>
		
        <el-table :data="tableData"
			
		>
            <el-table-column type="index" label="序号" ></el-table-column>
            <el-table-column prop="number" label="购买期数"></el-table-column>
            <el-table-column prop="indexTypeName" label="购买指标类型" width="110"></el-table-column>
            <el-table-column label="指标准确率">
				<template slot-scope="scope">
					{{ scope.row.backNumber}}中{{ scope.row.courrtNum}}期
				</template>
			</el-table-column>
            <el-table-column label="价格">
				<template slot-scope="scope">
					{{ scope.row.coin}}缩币
				</template>
			</el-table-column>
            <el-table-column prop="buyNum" label="认购次数" />
            <el-table-column prop="sumCoin" label="单个指标卖出缩币总额" ></el-table-column>
            <el-table-column prop="commissionRate" label="当前阶梯提成比例" >
				<template slot-scope="scope">
					{{ scope.row.rate * 100 || 0}}%
				</template>
			</el-table-column>
            <el-table-column prop="sumCommossionMoney" width="120" label="缩水师当期人民币收入(元)" ></el-table-column>
            <el-table-column prop="accumulateMoney" label="缩水师累计收入(元)" ></el-table-column>
        </el-table>
		<hxlPagin
			:queryParams="tableDataParams"
			@changePage="changePage($event,'tableData')"
		/>

        <!-- <div class="grid">
      <div>
        <span>收益数据软件标题</span>
        <span>发表时间</span>
        <span>设置缩币</span>
        <span>付费次数</span>
        <span>提成比例</span>
        <span>收入人名币</span>
        <span>人名币余额</span>
      </div>
      <div>
        <span>1</span>
        <span>1</span>
        <span>1</span>
        <span>1</span>
        <span>1</span>
        <span>1</span>
        <span>1</span>
      </div>
    </div> -->

        <div class="tableTit">缩水网提成阶梯执行方案</div>

        <!-- <el-table :data="tichengfangan"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}">
            <el-table-column label="单个彩种单期总销售额"
                             prop="price"></el-table-column>
            <el-table-column label="缩水师"
                             prop="ssq"></el-table-column>
            <el-table-column label="技巧师"
                             prop="jqs"></el-table-column>
            <el-table-column label="软件交易师"
                             prop="jys"></el-table-column>
        </el-table> -->

        <!-- <div class="grid">
      <div>
        <span>单个彩种单期总销售额</span>
        <span>缩水师</span>
        <span>技巧师</span>
        <span>软件交易师</span>
      </div>
      <div>
        <span>1</span>
        <span>1</span>
        <span>1</span>
        <span>1</span>
      </div>
    </div> -->

        <template>
            <template v-if="tc_rule.sss.arr.length">
                <el-table
                    :data="tc_rule.sss.arr"
                    :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }"
                >
					<el-table-column label="师种">缩水师</el-table-column>
                    <el-table-column label="彩种">
                        <template slot-scope="scope">
                            {{ 
                                scope.row.ticketType == 0 ? '双色球' :
                                scope.row.ticketType == 1 ? '大乐透' :
                                scope.row.ticketType == 2 ? '福彩3D' :
                                scope.row.ticketType == 3 ? '排列三' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="单个彩种单期总销售额"
                        prop="title"
                    ></el-table-column>
                    <el-table-column label="比例" prop="comRate">
                        <template slot-scope="scope">
                            {{ scope.row.comRate * 100 || 0}}%
                        </template>
                    </el-table-column>
                </el-table>
                <hxlPagin
                    :queryParams="tc_rule.sss.queryParams"
                    teacherType="sss"
                    @changePage="changePage"
                />
            </template>

            <template v-if="tc_rule.jqs.arr.length">
                <el-table
                    :data="tc_rule.jqs.arr"
                    :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }"
                >
					<el-table-column label="师种">技巧师</el-table-column>
                    <el-table-column label="彩种">
                        <template slot-scope="scope">
                            {{ 
                                scope.row.ticketType == 0 ? '双色球' :
                                scope.row.ticketType == 1 ? '大乐透' :
                                scope.row.ticketType == 2 ? '福彩3D' :
                                scope.row.ticketType == 3 ? '排列三' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="单个彩种单期总销售额"
                        prop="title"
                    ></el-table-column>
                    <el-table-column label="比例" prop="comRate">
                        <template slot-scope="scope">
                            {{ scope.row.comRate * 100  || 0}}%
                        </template>
                    </el-table-column>
                </el-table>
                <hxlPagin
                    :queryParams="tc_rule.jqs.queryParams"
                    teacherType="jqs"
                    @changePage="changePage"
                />
            </template>

            <template v-if="tc_rule.rjs.arr.length">
                <el-table
                    :data="tc_rule.rjs.arr"
                    :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }"
                >
					<el-table-column label="师种">软件师</el-table-column>
                    <el-table-column label="彩种">
                        <template slot-scope="scope">
                            {{ 
                                scope.row.ticketType == 0 ? '双色球' :
                                scope.row.ticketType == 1 ? '大乐透' :
                                scope.row.ticketType == 2 ? '福彩3D' :
                                scope.row.ticketType == 3 ? '排列三' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="单个彩种单期总销售额"
                        prop="title"
                    ></el-table-column>
                    <el-table-column label="比例" prop="comRate">
                        <template slot-scope="scope">
                            {{ scope.row.comRate * 100  || 0}}%
                        </template>
                    </el-table-column>
                </el-table>
                <hxlPagin
                    :queryParams="tc_rule.rjs.queryParams"
                    teacherType="rjs"
                    @changePage="changePage"
                />
            </template>

        </template>
    </div>
</template>

<script>
import qs from "qs";
import { incomeRecord } from "@/api/personalCenter";

import hxlPagin from "@/components/hxlPagin";
export default {
    components: { hxlPagin },
    data() {
        return {
            teacherType:[],

            lottery: {
                arr: [
                    // { value: "1", label: "全部彩种" },
                    // { value: "2", label: "双色球" },
                    // { value: "3", label: "大乐透" },
                    // { value: "4", label: "福彩3D" },
                    // { value: "5", label: "排列三" },
                ],
                active: "",
            },
            form: {
                time: "",
            },
            // tichengfangan: [
            //     { price: '20元以下', ssq: '25%', jqs: '25%', jys: '25%' },
            //     { price: '21-100元', ssq: '25%', jqs: '25%', jys: '25%' },
            //     { price: '101-500元', ssq: '25%', jqs: '25%', jys: '25%' },
            //     { price: '501元以上', ssq: '25%', jqs: '25%', jys: '25%' },
            // ],

            tableData: [],
			tableDataTotal:[],
			tableDataParams:{
				type:0,

				pageNum: 1,
				pageSize: 10,
				total:0
			},

            // 提成规则
            tc_rule: {
                sss: {
                    arr: [],
                    queryParams: {
                        pageNum: 1,
                        pageSize: 10,
                        total: 0,
                        // model: 0,
                    },
                },
                jqs: {
                    arr: [],
                    queryParams: {
                        pageNum: 1,
                        pageSize: 10,
                        total: 0,
                        // model: 1,
                    },
                },
                rjs: {
                    arr: [],
                    queryParams: {
                        pageNum: 1,
                        pageSize: 10,
                        total: 0,
                        // model: 2,
                    },
                },
            },
        };
    },
    async mounted() {
		this.get_lottery_type()
		this.get_income_statistics()

        this.getList();

        let pre_type = await this.$utils.getDictionary("pre_type");
        // console.log('彩种', pre_type.data);

         // 查找师种
        this.$utils.getDictionary("pre_product_model").then((res) => {
            res.data.forEach((item) => {
                item.remark = JSON.parse(item.remark);
                item = JSON.parse( JSON.stringify(item, [ "dictLabel", "dictValue", "remark", "status", ]) );
            });
            this.teacherType = res.data

            let teacherType = [
                {label:'缩水师',key:'sss'},
                {label:'技巧师',key:'jqs'},
                {label:'软件师',key:'rjs'},
            ]
            teacherType.forEach((item) => {
                this.getCommission_rules({
                    label:item.label,
                    value:this.queryTeacher(item.label),
                    key:item.key,
                });
            });
        });

    },
    methods: {
		// 切换收入统计彩种
		toggle_income_statistics(item,index){
			console.log('item',JSON.parse(JSON.stringify(item)));
			this.lottery.active = index
			this.tableDataParams.type = item.value
			this.get_income_statistics()
		},
		// 获取彩种种类
		get_lottery_type(){
			this.$http.get('/stage-api/pre/dict/lottery-type',{
				dictLabel:'pre_type',
			}).then(res => {
				let rows = res.data;
				console.log('pre_type',res.data);
				this.lottery.arr = rows.map(item => {
					return { value: item.dictValue, label: item.dictLabel };
				});
			});	
		},

		// 获取收入统计数据
		get_income_statistics(){
			this.$http.get('/stage-api/recharge/income-record',{
				params:this.tableDataParams
			}).then(res => {
				console.log('income-record',JSON.parse(JSON.stringify(res.data.rows)));
				let { rows, total } = res.data;
				this.tableData = rows;
				this.tableDataParams.total = total;
			})
		},

        // 查找师种
        queryTeacher(type) {
            return this.teacherType.filter(item=>item.remark.alias == type)[0].dictValue
        },

        getList() {
            incomeRecord().then((res) => {
                let { rows, total } = res.data;
                this.tableData = rows;
            });
        },

        // 获取彩种规则
        getCommission_rules(moduleType) {
            // console.log('moduleType',moduleType);

            let {label,value,key} = moduleType

            this.tc_rule[key].queryParams.model = value
            let params = qs.stringify(this.tc_rule[key].queryParams);

            this.$http
                .get("/stage-api/ticket/rule/on/list?" + params)
                .then((res) => {
                    // console.log(moduleType, JSON.parse(JSON.stringify(res)));
                    this.tc_rule[key].arr = res.rows;
                    this.tc_rule[key].queryParams.total = res.total;
                });
        },

        changePage(e , type ) {
            // console.log('changePage', e);

			if(type == 'tableData'){
				this.tableDataParams.pageNum = e;
				this.get_income_statistics()
				return
			}


            let { pageNum, teacherType } = e;
            this.tc_rule[teacherType].queryParams.pageNum = pageNum;
            // this.getCommission_rules(lotteryType);

            let teacherType1 = [
                {label:'缩水师',key:'sss'},
                {label:'技巧师',key:'jqs'},
                {label:'软件师',key:'rjs'},
            ]

            let label = teacherType1.filter(item=>item.key == teacherType)[0].label

            this.getCommission_rules({
                label,
                value:this.queryTeacher(label),
                key:teacherType,
            });

        },
    },
};
</script>

<style lang="scss" scoped>

.lottery_menu{
	display: flex;
	background-color: #EFEFEF;
	margin-top: 30px;
	>div{
		width: 100px;
		text-align: center;
		height: 50px;
		line-height: 50px;
		cursor: pointer;
		&.active{
			background-color: #409EFF;
			color: #fff;
		}
	}
}

.tableTit {
    text-align: center;
    background-color: #efefef;
    padding: 25px 0;
}
// .grid{
//   margin-top: 20px;
//   text-align: center;
//   >div{
//     display: grid;
//     grid-template-columns: repeat(7,1fr);
//     span{
//       border: 1px solid rgba(0,0,0,0.1);
//       display: inline-block;
//       padding: 10px 0;
//     }
//   }
// }
</style>